import React from "react";
import { Mail } from "lucide-react";

/**
 * Social sharing buttons (X, LinkedIn, Facebook, Email).
 * Used on the affiliate dashboard hero and the Links page.
 */
const SocialShareButtons = ({ url, message = "Check out R-Link Studio — the all-in-one video conferencing & webinar platform.", size = "md" }) => {
  if (!url) return null;
  const enc = encodeURIComponent(url);
  const msg = encodeURIComponent(message);

  const links = [
    {
      key: "x",
      label: "X",
      href: `https://twitter.com/intent/tweet?url=${enc}&text=${msg}`,
      bg: "bg-black hover:bg-neutral-800",
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
      ),
    },
    {
      key: "linkedin",
      label: "LinkedIn",
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc}`,
      bg: "bg-[#0A66C2] hover:bg-[#0954a0]",
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
          <path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19a.66.66 0 000 .14V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z" />
        </svg>
      ),
    },
    {
      key: "facebook",
      label: "Facebook",
      href: `https://www.facebook.com/sharer/sharer.php?u=${enc}`,
      bg: "bg-[#1877F2] hover:bg-[#1462c4]",
      icon: (
        <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
          <path d="M22 12a10 10 0 10-11.56 9.88V14.9H7.9V12h2.54V9.8c0-2.5 1.5-3.9 3.78-3.9 1.1 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.45 2.9h-2.33v6.98A10 10 0 0022 12z" />
        </svg>
      ),
    },
    {
      key: "email",
      label: "Email",
      href: `mailto:?subject=${encodeURIComponent("Check out R-Link Studio")}&body=${msg}%0A%0A${enc}`,
      bg: "bg-white/10 hover:bg-white/20",
      icon: <Mail className="w-4 h-4" />,
    },
  ];

  const dim = size === "sm" ? "w-8 h-8" : "w-9 h-9";

  return (
    <div className="flex items-center gap-2">
      {links.map((l) => (
        <a
          key={l.key}
          href={l.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Share on ${l.label}`}
          title={`Share on ${l.label}`}
          className={`${dim} ${l.bg} flex items-center justify-center rounded-lg text-white transition-colors`}
        >
          {l.icon}
        </a>
      ))}
    </div>
  );
};

export default SocialShareButtons;
